import { render, staticRenderFns } from "./HomeJumboText.vue?vue&type=template&id=a70c4a40&scoped=true&"
import script from "./HomeJumboText.vue?vue&type=script&lang=js&"
export * from "./HomeJumboText.vue?vue&type=script&lang=js&"
import style0 from "./HomeJumboText.vue?vue&type=style&index=0&id=a70c4a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70c4a40",
  null
  
)

export default component.exports